module.exports = __webpack_public_path__ + "static/media/cancel.e9ad79ec.svg";